const SERVICE_WORKER_TIMEOUT_MS = 3000;

function canUseServiceWorkers(): boolean {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
}

export async function waitForPortalServiceWorkerController(): Promise<boolean> {
  if (!canUseServiceWorkers()) {
    return false;
  }

  if (navigator.serviceWorker.controller) {
    return true;
  }

  return new Promise((resolve) => {
    const timer = window.setTimeout(() => { resolve(false); }, SERVICE_WORKER_TIMEOUT_MS);

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.clearTimeout(timer);
      resolve(true);
    }, {once: true});
  });
}

export async function unregisterPortalServiceWorkersAndClearCaches(): Promise<void> {
  try {
    if (canUseServiceWorkers()) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => { return registration.unregister(); }));
    }

    if (typeof caches !== 'undefined') {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((cacheKey) => { return caches.delete(cacheKey); }));
    }
  } catch (error) {
    console.warn('[Portal] Failed to unregister service workers or clear caches:', error);
  }
}